import {curry} from 'ramda';
import humanizeRange from '@pluto/humanize-moment-range';
import {
    FilterHandlers,
    FiltersKeys,
    OnInputChangeEvent,
} from '../../QCWorkflow/QCManager/QCManagerTypes';
import {DateRangeState} from '../daterange-picker';

export const getDatesRange = (dueDates: DateRangeState, finishDates: DateRangeState) =>
    dueDates ? humanizeRange(dueDates) : humanizeRange(finishDates);

export const makeHandleFilters = curry(
    (filterHandlers: FilterHandlers, key: FiltersKeys, e: OnInputChangeEvent) => {
        const {
            setFilters,
            setPage,
            setQuery,
            history,
            setQCJobs,
            rowsPerPage,
            filters,
            title,
            sortOrder,
            sortBy,
            route,
            dueDates,
            finishDates,
        } = filterHandlers;
        const [dateStart, dateEnd] = getDatesRange(dueDates, finishDates);
        const {value} = e.target;
        const newFilters = {
            ...filters,
            [key]: value,
        };
        const query = {
            ...newFilters,
            offset: 0,
            title,
            limit: rowsPerPage,
            sortOrder,
            sortBy,
            dateStart,
            dateEnd,
        };

        setPage(0);
        setQuery(history, route, query);
        setFilters(newFilters);
        setQCJobs(query);
    }
);
